const detectors = [
  (value) => {
    const match = value.match(/^(?:\s*(?:qty|quantity|počet|pocet|množství|mnozstvi)\s*[:=]?\s*)(\d+)\s+(.+)$/i);
    if (match) {
      return {
        quantity: Number.parseInt(match[1], 10) || 1,
        query: match[2].trim(),
      };
    }
    return null;
  },
  (value) => {
    const match = value.match(/^(\d+)\s*(?:x|×|\*)?\s*(.+)$/i);
    if (match) {
      return {
        quantity: Number.parseInt(match[1], 10) || 1,
        query: match[2].trim(),
      };
    }
    return null;
  },
  (value) => {
    const match = value.match(/^(\d+)\s*(?:ks|kus(?:y|ů)?|pcs|pieces|balení|baleni)\b[^A-Za-z0-9]*(.+)$/i);
    if (match) {
      return {
        quantity: Number.parseInt(match[1], 10) || 1,
        query: match[2].trim(),
      };
    }
    return null;
  },
  (value) => {
    const match = value.match(/^(.*?)(\d+)\s*(?:ks|kus(?:y|ů)?|pcs|pieces|balení|baleni)\b\s*(.*)$/i);
    if (match) {
      const quantity = Number.parseInt(match[2], 10) || 1;
      const query = `${match[1]} ${match[3]}`.trim().replace(/\s{2,}/g, ' ');
      return {
        quantity,
        query,
      };
    }
    return null;
  },
  (value) => {
    const match = value.match(/^(.*?)[,;-]\s*(\d+)\s*(?:ks|kus(?:y|ů)?|pcs|pieces)?$/i);
    if (match) {
      return {
        quantity: Number.parseInt(match[2], 10) || 1,
        query: match[1].trim(),
      };
    }
    return null;
  },
  (value) => {
    const match = value.match(/^(.*?)(?:\s(?:x|×|\*)\s*)(\d+)\b\s*(.*)$/i);
    if (match) {
      const quantity = Number.parseInt(match[2], 10) || 1;
      const query = `${match[1]} ${match[3]}`.trim().replace(/\s{2,}/g, ' ');
      return {
        quantity,
        query,
      };
    }
    return null;
  },
];

export const parseDemandLines = (text) =>
  text
    .split('\n')
    .map((line) => {
      const trimmed = line.trim();
      if (!trimmed) {
        return null;
      }
      for (const detect of detectors) {
        const result = detect(trimmed);
        if (result && result.query) {
          return {
            raw: line,
            quantity: result.quantity,
            query: result.query,
          };
        }
      }
      return {
        raw: line,
        quantity: 1,
        query: trimmed,
      };
    })
    .filter(Boolean);

export default parseDemandLines;
